import React from "react";

const DocumentStatusRing = ({
  size = 80,
  strokeWidth = 5,
  rejected,
  approved,
  reviewPending,
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const segments = [
    { percentage: reviewPending, color: "#A0A0A0" }, // gray
    { percentage: approved, color: "#017C57" }, // green
    { percentage: rejected, color: "#e74c3c" }, // red
  ];
  let offset = 0;

  return (
    <div>
      <svg width={size} height={size}>
        <g transform={`rotate(-90 ${size / 2} ${size / 2})`}>
          {segments.map((segment, index) => {
            if (segment.percentage <= 0) return null;
            const length = (segment.percentage / 100) * circumference;
            const dasharray = `${length} ${circumference - length}`;
            const circle = (
              <circle
                key={index}
                r={radius}
                cx={size / 2}
                cy={size / 2}
                fill="transparent"
                stroke={segment.color}
                strokeWidth={strokeWidth}
                strokeDasharray={dasharray}
                strokeDashoffset={-offset}
                strokeLinecap="round"
              />
            );
            offset += length;
            return circle;
          })}
        </g>
      </svg>
    </div>
  );
};

export default DocumentStatusRing;
